module.exports = __webpack_public_path__ + "img/segob-mx.4903eb09.png";